export class WellKnownHubModules {
  static readonly studentHub: string = "student-hub";
}
